module.exports = __webpack_public_path__ + "img/swiper7.61710ec1.png";